module.exports = __webpack_public_path__ + "assets/img/user-1.f5ce7654.jpg";